import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface AppState {
  projectName: string;
  idfContent: string;
  isDirty: boolean;
  activePanel: 'editor' | 'graph' | 'viewer' | 'results';
  setProjectName: (name: string) => void;
  setIdfContent: (content: string) => void;
  setActivePanel: (panel: AppState['activePanel']) => void;
  markClean: () => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        projectName: 'Untitled Project',
        idfContent: '',
        isDirty: false,
        activePanel: 'editor',

        setProjectName: (name) => {
          set({ projectName: name, isDirty: true });
        },

        setIdfContent: (content) => {
          set({ idfContent: content, isDirty: true });
        },

        setActivePanel: (panel) => {
          set({ activePanel: panel });
        },

        markClean: () => {
          set({ isDirty: false });
        },
      }),
      {
        name: 'envelop-storage',
        partialize: (state) => ({
          projectName: state.projectName,
          idfContent: state.idfContent,
        }),
      }
    ),
    { name: 'AppStore' }
  )
);
